module.exports = {"single":["W_8i6MH0Z7G_c3HrGlDBKj-VRYLef_pDvrark1gHOVs","vcts__2y35pRQ1KYpj7u0sipyXcDq1vhuZ0sCdGTjmo","RqFvk2tk84pPg1_j47irPEkY_gxKF54uE8zDX-pzNCs"],"album":[],"podcast":[],"soundEffect":[]}


//////////////////
// WEBPACK FOOTER
// ./src/config/blocked.json
// module id = gt6U
// module chunks = 1